<template>
  <div>
    <template v-if="showAddRow()">
      <h4 class="heading">Set Coders, Patient Types and Dates and choose Add Coders
      </h4>
      <el-form label-position="top" ref="addCodersForm" @submit.prevent.native :model="addRow" :rules="addRow.rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="numberOfCoders" label="Number of Coders" style="width: 90%;">
              <el-input-number v-model="addRow.numberOfCoders" :min="1" :max="25"></el-input-number>
            </el-form-item>
            <el-form-item prop="patientTypes" label="Patient Types" style="width: 90%;">
              <el-select multiple v-model="addRow.patientTypes" style="width: 100%" @change="handlePatientTypeChange(addRow)">
                <el-option value="selectAll" label="Select All"></el-option>
                <el-option v-for="pt in patientTypes" :key="pt.key" :label="pt.key" :value="pt.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="scheduledDays" :label="`Select Scheduled Days`">
              <CalendarPicker class="coderCalendar" style="margin: 0" v-model="addRow.scheduledDays" :pageDate="startDate">
              </CalendarPicker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button id="addCoders" plain @click="addCoders"><i class="mdi mdi-account-multiple-plus coderIcon"></i>Add
        Coders</el-button>
    </template>
    <template v-else>
      <el-alert title="Request Period Locked, please contact HIA for any changes" type="warning" :closable="false">
      </el-alert>
    </template>
    <h4 class="heading top-margin-30">
      {{`Coder Details - ${coders.length} ${coders.length === 1 ? 'Coder' : 'Coders'} Requested`}}
      <el-button-group style="float: right; position: relative; bottom: 10px;">
        <el-button :disabled="coders.length === 0 || !showAddRow()" id="clearCoders" plain @click="clearCoders"
          style="border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important"><i class="mdi mdi-account-multiple-minus coderIcon"></i>Clear Coders
        </el-button>
        <el-button :disabled="coders.length === 0" id="clearCoders" plain @click="showMasterCalendarDialog = true"
          style="border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important"><i class="el-icon-date coderIcon" style="font-size: 16px;"></i>Master
          Calendar</el-button>
      </el-button-group>
    </h4>
    <div>
      <el-table v-loading="loading" element-loading-spinner="nucleus-loader" id="editCodersTable" ref="editCodersTable" class="top-margin" :data="coders"
        empty-text="No Coders Added Yet">
        <el-table-column prop="" label="" width="35">
          <template slot-scope="scope">
            <i v-if="showAddRow()" class="el-icon-close showOnHover" @click="deleteCoder(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="coder" label="Coder" width="120">
        </el-table-column>
        <el-table-column prop="patientTypes" label="Patient Types">
          <template slot-scope="scope">
            <el-select :disabled="!showAddRow()" multiple v-model="scope.row.patientTypes" style="width: 95%;" @change="handlePatientTypeChange(scope.row)"
              @remove-tag="handlePatientTypeRemoveTag(scope.row)" @visible-change="handlePatientTypeVisibleChange($event, scope.row)">
              <el-option value="selectAll" label="Select All"></el-option>
              <el-option v-for="pt in patientTypes" :key="pt.key" :label="pt.key" :value="pt.key">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="scheduledDays" label="Scheduled Days" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.scheduledDays.length}}
              {{ scope.row.scheduledDays.length === 1 ? 'Day' : 'Days' }}</span>
            <i style="margin: 0px 0px 0px 10px; cursor: pointer; font-size: 18px; height: 19px; vertical-align: middle;" class="el-icon-date"
              @click="openCalendar(scope.row)"></i>
            <el-dialog :title="scope.row.coder" class="calendar-modal" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
              :visible.sync="scope.row.showCalendar" width="100">
              <CalendarPicker v-model="scope.row.scheduledDays" :pageDate="startDate" @change="handleCalendarChange(scope.row)">
              </CalendarPicker>
              <el-alert style="margin-top: 20px;" type="warning" v-if="calendarModalMessage" :closable="false">
                {{calendarModalMessage}}</el-alert>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCalendarSave(scope.row)">Cancel</el-button>
                <el-button :disabled="scope.row.calendarSaveDisabled" type="primary" @click="saveAndCloseCalendar(scope.row)">
                  Apply</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="showMasterCalendarDialog" width="70vw">
      <MasterCalendarPicker :coders="coders" :pageDate="startDate">
      </MasterCalendarPicker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showMasterCalendarDialog = false">Close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import { differenceInCalendarDays } from 'date-fns'
  import CalendarPicker from '@/components/CalendarPicker/CalendarPicker'
  import MasterCalendarPicker from '@/components/CalendarPicker/MasterCalendarPicker'

  export default {
    props: {
      startDate: {
        type: Date,
        required: true
      },
      coders: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean
      }
    },
    data: function () {
      return {
        scheduledDaysBackup: [],
        patientTypesTracker: [],
        calendarModalMessage: '',
        showMasterCalendarDialog: false,
        addRow: {
          numberOfCoders: 1,
          patientTypes: [],
          scheduledDays: [],
          rules: {
            patientTypes: [
              { required: true, message: 'Please Select Patient Types', trigger: 'change' }
            ],
            scheduledDays: [
              { required: true, message: 'Please Select Scheduled Days', trigger: 'change' }
            ],
            numberOfCoders: [
              { required: true, message: 'Please Set Number of Coders', trigger: 'change' }
            ]
          }
        },
        patientTypes: [
          { key: 'Inpatient' },
          { key: 'Ambulatory Surgery' },
          { key: 'Ancilliary' },
          { key: 'Emergency Department' },
          { key: 'Other Outpatients with Procedures' }
        ]
      }
    },
    name: 'CodingRequestAcuteCoderDetails',
    methods: {
      addCoders() {
        this.$refs['addCodersForm'].validate((valid) => {
          if (valid) {
            let newCoders = []

            let maxCoderNumber = 0
            if (this.coders && this.coders.length > 0) {
              maxCoderNumber = Math.max.apply(Math, this.coders.map((x) => { return x.coderNumber }))
            }

            for (let i = 0; i < this.addRow.numberOfCoders; i++) {
              let l = this.coders.length
              newCoders.push({
                coder: `Coder #${l + i + 1}`,
                coderNumber: maxCoderNumber + i + 1,
                patientTypes: this.addRow.patientTypes,
                scheduledDays: this.addRow.scheduledDays.slice(), // copy
                showCalendar: false,
                calendarSaveDisabled: true
              })
            }

            this.$emit('add', newCoders)

            this.addRow.numberOfCoders = 1
            this.addRow.patientTypes = []
            this.addRow.scheduledDays = []
            this.$refs['addCodersForm'].resetFields()
          }
        })
      },
      deleteCoder(coder) {
        this.$emit('delete', coder)
      },
      getNumberOfWorkingDays() {
        var selectedMonth = this.getSelectedMonth()
        var lastDay = new Date(selectedMonth.year, selectedMonth.month + 1, 0).getDate()
        var workingDays = 0
        for (let i = 1; i <= lastDay; i++) {
          let date = new Date(selectedMonth.year, selectedMonth.month, i)
          if (date.getDay() !== 0 && date.getDay() !== 6) {
            workingDays++
          }
        }
        return workingDays
      },
      handlePatientTypeChange(coder) {
        if (coder.patientTypes.includes('selectAll')) {
          coder.patientTypes = this.patientTypes.map(option => option.key)
        }
      },
      handlePatientTypeRemoveTag(coder) {
        this.$emit('changePatientTypes', coder)
      },
      handlePatientTypeVisibleChange(isOpen, coder) {
        if (isOpen) {
          this.patientTypesTracker = coder.patientTypes.slice()
        } else {
          if (JSON.stringify(this.patientTypesTracker) !== JSON.stringify(coder.patientTypes)) {
            this.$emit('changePatientTypes', coder)
          }
        }
      },
      openCalendar(row) {
        this.calendarModalMessage = ''
        this.scheduledDaysBackup = row.scheduledDays.slice()
        row.showCalendar = true
      },
      cancelCalendarSave(row) {
        row.scheduledDays = this.scheduledDaysBackup
        row.showCalendar = false
        row.calendarSaveDisabled = true
      },
      handleCalendarChange(row) {
        row.calendarSaveDisabled = false
      },
      saveAndCloseCalendar(row) {
        if (row.scheduledDays.length === 0) {
          this.calendarModalMessage = 'Please select at least one day'
          return
        }

        row.showCalendar = false
        row.calendarSaveDisabled = true
        this.$emit('changeDates', row)
      },
      showAddRow() {
        let lastDayOfMonth = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0)
        return differenceInCalendarDays(lastDayOfMonth, new Date()) >= 0
      },
      clearCoders() {
        this.$emit('clearCoders')
      }
    },
    components: {
      CalendarPicker,
      MasterCalendarPicker
    }
  }
</script>

<style scoped>
  >>>.calendar-modal .el-dialog {
    width: 400px !important;
  }

  >>>.calendar-modal .el-dialog__body {
    padding: 20px;
    margin: auto;
    overflow: inherit;
  }

  >>>tr:hover>td i.showOnHover {
    display: block;
    cursor: pointer;
  }

  >>>tr>td i.showOnHover {
    display: none;
  }

  >>>.coderCalendar {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 0px 20px 15px 20px;
  }

  >>>.vdp-datepicker__calendar .cal-cell.selected {
    /* background: #57CCF4; */
    background: rgba(87, 204, 244, .5);

  }

  /* BUTTON ICONS*/
  .coderIcon {
    font-size: 20px;
    float: left;
    height: 12px;
    margin: -3px 5px 0px 0px;
  }

  .requestButtonIcons {
    font-size: 25px;
    float: right;
    margin: -5px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    height: 14px;
    width: 14px;
  }
</style>
